export default {
  kether: {
    plotInfo: [],
    plotInfoAggregateData: {
      widthHeight: {},
      area: {},
    },
  },
};
